import React from 'react'
import styles from './HistorySection.module.css'
import { useLang } from '../../i18n/LanguageContext'

const YEARS = ['2014', '2016', '2018', '2021', '2023', '2025']

export default function HistorySection() {
  const { T } = useLang()

  return (
    <section className={`section ${styles.history}`} id="historia">
      <div className="container">
        <div className={styles.header}>
          <p className="section-label">{T.history.label}</p>
          <h2 className="section-title">
            {T.history.heading1}
            <br />
            {T.history.heading2}
          </h2>
        </div>

        <div className={styles.timeline}>
          {T.history.milestones.map((m, i) => (
            <div key={YEARS[i]} className={`${styles.item} ${i % 2 === 0 ? styles.left : styles.right}`}>
              <div className={styles.yearBadge}>{YEARS[i]}</div>
              <div className={styles.card}>
                <h3 className={styles.cardTitle}>{m.title}</h3>
                <p className={styles.cardDesc}>{m.desc}</p>
              </div>
            </div>
          ))}
          <div className={styles.line} aria-hidden="true" />
        </div>
      </div>
    </section>
  )
}
